import React, { memo } from 'react';
import { Image, LazyLoad } from '@tangibleplay/core-ui';

import { StyledProductRender } from './ProductRender.styles';

import { ProductRenderProps } from './ProductRender.types';

import { ProductBadge } from '../../';

//TODO Remove Duplicate "customClass" prop (duplicate of "customClassnames")
const ProductRender = ({
  image,
  skuKey,
  size = 200,
  includeMicroData = true,
  isHovering,
  disableHover,
  onClick,
  lazyLoad,
  badge,
  haveTouchDevice = false,
  componentClassname = 'product-render',
  customClassnames = '',
  customClass = '',
  customStyle = '',
}: ProductRenderProps) => {
  const noHover = disableHover || haveTouchDevice || !image.hover;

  const imgixControlProps = {
    w: size,
    h: size,
  };

  const getRender = () => (
    <>
      {includeMicroData && <meta itemProp="image" content={image.main}></meta>}
      <Image
        className={`${componentClassname}__image ${componentClassname}__image-no-hover`}
        src={image.main}
        alt=""
        data-skukey={skuKey}
        style={{ backgroundSize: 'contain' }}
        imgixControlProps={imgixControlProps}
        imageWidth={size}
        imageHeight={size}
      />
      {!noHover && image.hover && (
        <Image
          className={`${componentClassname}__image ${componentClassname}__image-hover`}
          src={image.hover}
          alt=""
          style={{ backgroundSize: 'contain' }}
          imgixControlProps={imgixControlProps}
          imageWidth={size}
          imageHeight={size}
        />
      )}
    </>
  );

  return (
    <StyledProductRender
      className={`${componentClassname} ${customClassnames} ${customClass}`}
      customStyle={customStyle}
      isHovering={isHovering}
      data-qa="product-render"
      onClick={onClick}
    >
      <div className={`${componentClassname}__image-holder`}>
        {lazyLoad ? (
          <LazyLoad placeholder={<div style={{ width: size, height: size }} />}>
            {getRender()}
          </LazyLoad>
        ) : (
          getRender()
        )}
        <ProductBadge {...badge} />
      </div>
    </StyledProductRender>
  );
};
ProductRender.displayName = 'ProductRender';

export default memo(ProductRender);
